const translations = {
    required: 'This item is required'
};

export default translations;
